import AppConstants from '../config/app.constants';

let CostCenterService = function ($http, $q){

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/cost-center`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/cost-center/create`, { data, branchId })
            .then((res) => {
                return res.data;
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/cost-center/${id}/update`, data)
            .then((res) => {
                return res.data;
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/cost-center/${id}`)
            .then((res) => {
                return res.data;
            })
    }

    return {
        all,
        create,
        update,
        get
    };
};

CostCenterService.$inject = ['$http', '$q'];

export default CostCenterService;


// WEBPACK FOOTER //
// ./client/app/services/cost-center.service.js